import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        show_float: 0
    },
    mutations: {
        change_float (state, if_show) {
            state.show_float = if_show
        }
    },
    actions: {
        change_float (context, data) {
            context.commit('change_float', data)
        }
    }

})

export default store